export default "__VITE_ASSET__CaOq6hK3__"